import { render } from "./layout-horizontal-overlay.vue?vue&type=template&id=72f16cdb"
import script from "./layout-horizontal-overlay.vue?vue&type=script&lang=js"
export * from "./layout-horizontal-overlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__